import {
  Box,
  useTheme,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { tokens } from "../../theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Proveedor = ({ data, onNext, onBack, onDataChange }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const mainBlue = "#273c7d";

  // Inicializa el estado local con los datos existentes
  const [formData, setFormData] = useState(data || {});
  const [selectedServices, setSelectedServices] = useState(data.services || []);

  // Sincroniza los datos locales con los globales cuando cambien
  useEffect(() => {
    setFormData(data || {});
    setSelectedServices(data.services || []);
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    onDataChange({ ...updatedFormData, services: selectedServices });
  };

  const handleServiceChange = (service) => {
    const updatedServices = selectedServices.includes(service)
      ? selectedServices.filter((s) => s !== service)
      : [...selectedServices, service];
    setSelectedServices(updatedServices);
    onDataChange({ ...formData, services: updatedServices });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      formData.operator &&
      formData.contractNumber &&
      formData.claimDate &&
      (selectedServices.length > 0 || formData.otherService)
    ) {
      const combinedServices = [...selectedServices];
      if (formData.otherService) {
        combinedServices.push(formData.otherService);
      }

      onDataChange({ ...formData, services: combinedServices });
      onNext();
    } else {
      alert("Por favor, completa todos los campos obligatorios.");
    }
  };

  return (
    <Box>
      <Typography
        variant="h6"
        color={colors.grey[300]}
        mb={4}
        textAlign="center"
      >
        Brinde información sobre el operador y los servicios afectados.
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={4}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            <Box mb={3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={mainBlue}
                gutterBottom
              >
                Operador Denunciado
              </Typography>
              <TextField
                fullWidth
                color="secondary"
                name="operator"
                label="Nombre del Operador"
                value={formData.operator || ""}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Box>

            <Box mb={3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={mainBlue}
                gutterBottom
              >
                Número de Contrato
              </Typography>
              <TextField
                fullWidth
                color="secondary"
                name="contractNumber"
                label="Número de contrato"
                value={formData.contractNumber || ""}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Box>

            <Box mb={3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={mainBlue}
                gutterBottom
              >
                Fecha de Reclamo
              </Typography>
              <TextField
                fullWidth
                color="secondary"
                name="claimDate"
                type="date"
                value={formData.claimDate || ""}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" fontWeight="bold" color={mainBlue} mb={2}>
              Servicios Afectados
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
                mb: 3,
                "& .MuiCheckbox-root": {
                  color: `${mainBlue} !important`,
                },
              }}
            >
              {[
                "Telefonía Fija",
                "Telefonía Móvil",
                "TV por Cable",
                "TV por Satélite",
                "Internet Fijo",
                "Internet Móvil",
              ].map((service) => (
                <FormControlLabel
                  key={service}
                  control={
                    <Checkbox
                      checked={selectedServices.includes(service)}
                      onChange={() => handleServiceChange(service)}
                    />
                  }
                  label={service}
                />
              ))}
            </Box>

            <Typography
              variant="h6"
              fontWeight="bold"
              color={mainBlue}
              gutterBottom
            >
              ¿Otro Servicio?
            </Typography>
            <TextField
              fullWidth
              color="secondary"
              name="otherService"
              label="Especifique otro servicio"
              value={formData.otherService || ""}
              onChange={handleInputChange}
              variant="outlined"
            />
          </Grid>

          {/* Buttons */}
          <Grid item xs={12} container justifyContent="space-between" mt={4}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={onBack}
              sx={{
                color: colors.grey[300],
                borderColor: colors.grey[500],
                borderRadius: "10px",
                px: 4,
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  borderColor: mainBlue,
                  color: mainBlue,
                },
              }}
            >
              Anterior
            </Button>
            <Button
              type="submit"
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              sx={{
                backgroundColor: mainBlue,
                color: "white",
                borderRadius: "10px",
                px: 6,
                py: 1.2,
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#1c2a4a",
                  transform: "translateX(5px)",
                  boxShadow: "0px 8px 15px rgba(0,0,0,0.2)",
                },
              }}
            >
              Continuar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Proveedor;
